query PollAgentStatus($companyId: ID!) {
  company(id: $companyId) {
    agentRegistration {
      id
      databaseId
      status
      hostname
      ipAddress
      agentVersion
      lastHeartbeatAt
      publicKeyPem
      createdAt
    }
  }
}